import React from 'react';
import { Typography } from '@mui/material';
import Modal from 'mui/components/elements/DS_Modal';

import { formatDate, formatTime } from 'utils/momentHelpers';
import { pushGTMEvent } from 'utils/gtm';
import { StyledAppointmentContent, StyledLink, StyledQuestion } from './RescheduleModalStyles';

function RescheduleModal({
  rescheduleHeadlineStepFinalize,
  rescheduleQuestionStepFinalize,
  rescheduleLinkLabelStepFinalize,
  open,
  onClose,
  bookingData,
}) {
  const shopAddress = `${bookingData?.shopStreet}, ${bookingData?.shopPostalCode} ${bookingData?.shopCity}`;
  const shopName = `DR SMILE® ${bookingData?.shopTitle}`;

  const goToRescheduleLink = $event => {
    $event.preventDefault();

    pushGTMEvent({
      eventAction: 'Reschedule Link Clicked',
      eventCategory: 'Booking funnel',
    });

    const currentUrl = new URL(window.location.origin + window.location.pathname);
    currentUrl.searchParams.set('id', bookingData?.encryptedId);

    // didn't use Gatsby Link or navigate because adding the
    // new param (id) on the same route (booking) updates the url but doesn't rerender the page
    window.location.href = currentUrl.href;

    return false;
  };

  return (
    <Modal
      data-test="modal-modal"
      open={open}
      handleClose={onClose}
      modalHeading={rescheduleHeadlineStepFinalize}
      headingVariant="DS_copyBigBold"
      ariaDescribedby="modal-description"
    >
      <div data-test="modal-content">
        {bookingData && (
          <StyledAppointmentContent id="modal-description">
            <Typography variant="DS_copyMediumBold" component="p">
              {formatDate(bookingData?.meetingDate)}, {formatTime(bookingData?.startMeetingTime)}
            </Typography>
            <Typography variant="DS_copyMediumRegular" component="p">
              {shopName}
            </Typography>
            <Typography variant="DS_copyMediumRegular" component="p">
              {shopAddress}
            </Typography>
            <Typography variant="DS_copyMediumRegular" component="p">
              {bookingData?.shopPhone}
            </Typography>
          </StyledAppointmentContent>
        )}

        <StyledQuestion variant="DS_copyMediumRegular" component="p">
          {rescheduleQuestionStepFinalize}{' '}
          <StyledLink onClick={goToRescheduleLink}>{rescheduleLinkLabelStepFinalize}</StyledLink>
        </StyledQuestion>
      </div>
    </Modal>
  );
}

export default RescheduleModal;
